import {
  every,
  filterL,
  flatMapL,
  go,
  head,
  isNil,
  mapL,
  not,
  rangeL,
  zip,
} from "fxjs/es";
export const checkAreaIntersection = ({ points1, points2 }) => {
  const [lines1, lines2] = mapL(
    (points) =>
      go(
        rangeL(points.length),
        mapL((i) => i + 1),
        mapL((i) => i % points.length),
        mapL((i) => points[i]),
        zip(points)
      ),
    [points1, points2]
  );
  return go(
    lines1,
    flatMapL((l1) => mapL((l2) => [l1, l2], lines2)),
    filterL(([l1, l2]) => {
      const det =
        (l1[1].x - l1[0].x) * (l2[1].y - l2[0].y) -
        (l2[1].x - l2[0].x) * (l1[1].y - l1[0].y);
      if (!det) {
        return false;
      }
      const s =
        ((l2[1].y - l2[0].y) * (l2[1].x - l1[0].x) +
          (l2[0].x - l2[1].x) * (l2[1].y - l1[0].y)) /
        det;
      const t =
        ((l1[0].y - l1[1].y) * (l2[1].x - l1[0].x) +
          (l1[1].x - l1[0].x) * (l2[1].y - l1[0].y)) /
        det;
      return every(
        (v) => 0 - Number.EPSILON <= v && v <= 1 + Number.EPSILON,
        [s, t]
      );
    }),
    head,
    isNil,
    not
  );
};
